import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { webColors } from '../../../../constants/webStyles';
import logoImage from '../../../../assets/images/supermedic-logo-web.png';
import { useIsMobile } from '../../../../hooks/useIsMobile';

const AuthHeader = ({ currentView, onShowLogin, onShowRegister }) => {
  const isLoginView = currentView === 'login' || currentView === 'forgotPassword';
  const isMobile = useIsMobile();

  return (
    <View style={[styles.header, isMobile && styles.headerMobile]}>
      <TouchableOpacity onPress={onShowRegister}>
        <Image source={logoImage} style={[styles.logoImage, isMobile && styles.logoImageMobile]} resizeMode="contain" />
      </TouchableOpacity>
      <View style={styles.headerRight}>
        {isLoginView ? (
          <>
            {!isMobile && <Text style={styles.headerText}>Don't have an account? </Text>}
            <TouchableOpacity onPress={onShowRegister}>
              <Text style={styles.headerLink}>Create account</Text>
            </TouchableOpacity>
          </>
        ) : (
          <>
            {!isMobile && <Text style={styles.headerText}>Already have an account? </Text>}
            <TouchableOpacity onPress={onShowLogin}>
              <Text style={styles.headerLink}>Log in</Text>
            </TouchableOpacity>
          </>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    backgroundColor: webColors.cardBackground,
    paddingHorizontal: 40,
    paddingVertical: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: webColors.border,
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  logoImage: {
    height: 40,
    width: 200,
  },
  headerRight: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontSize: 14,
    color: webColors.textMuted,
  },
  headerLink: {
    color: webColors.primary,
    fontWeight: '600',
    fontSize: 14,
  },
  headerMobile: {
    paddingHorizontal: 16,
  },
  logoImageMobile: {
    width: 140,
  },
});

export default AuthHeader;
